import {Expose} from "class-transformer";
import {CommandPayload} from "./command-payload";

/**
 * Payload of `RecolorKeywordCommand` and `RecolorIssueStatusCommand` (feature plan 0074, ADR-016).
 *
 * `uid` belongs in the payload: both backend commands find their entity through `PayloadUidTrait::getEntityId()`,
 * which reads it from there — the generic path puts the uid only beside the payload, as `mainEntityUid`.
 *
 * Only the colours that CHANGED are sent (review 0074-01): the backend leaves a missing key as it is, so a tab that
 * changes only one colour never writes back its possibly stale copy of the other one. `textColor` is sent also as
 * `null` ("back to automatic"); an unset field is left out of the DTO already (`exposeUnsetFields: false` in
 * `TransformerHelper`).
 */
export class RecolorContent extends CommandPayload {

    @Expose()
    public uid: string;

    @Expose()
    public color?: string;

    @Expose()
    public textColor?: string | null;

    public constructor(uid: string, changes: {color?: string, textColor?: string | null} = {}) {
        super();
        this.uid = uid;
        if (changes.color !== undefined) {
            this.color = changes.color;
        }
        if (changes.textColor !== undefined) {
            this.textColor = changes.textColor;
        }
    }

    /** The changed colours of a Colorizable entity — `changed` names the changed fields (`color`, `textColor`). */
    public static of(entity: {uid: string, color: string, textColor: string | null}, changed: ReadonlyArray<string>): RecolorContent {
        return new RecolorContent(entity.uid, {
            ...(changed.includes('color') ? {color: entity.color} : {}),
            ...(changed.includes('textColor') ? {textColor: entity.textColor} : {}),
        });
    }
}
